import { ChatPresetResponse } from '../types/chat';

export const initialChatChips = [
  { label: 'Request a Quote', actionKey: 'quote' },
  { label: 'Book Consultation', actionKey: 'book' },
  { label: 'Development Services', actionKey: 'dev' },
  { label: 'Office & Contact Info', actionKey: 'contact' },
];

export const chatPresetResponses: Record<string, ChatPresetResponse> = {
  quote: {
    actionKey: 'quote',
    response: 'Great! You can use our interactive Proposal Estimator on the page or submit an instant RFP inquiry. Would you like to schedule a 1-on-1 discovery call with our tech lead?',
    followUpChips: [
      { label: 'Book Consultation Call', actionKey: 'book' },
      { label: 'Explore Services', actionKey: 'dev' },
    ],
  },
  book: {
    actionKey: 'book',
    response: 'You can book a 1-on-1 appointment directly using our online scheduler! Our lead engineer and project manager will review your technical requirements.',
    followUpChips: [
      { label: 'View Contact Details', actionKey: 'contact' },
      { label: 'Development Services', actionKey: 'dev' },
    ],
  },
  dev: {
    actionKey: 'dev',
    response: 'Technook specializes in front-end & back-end software engineering, mobile apps for iOS & Android, enterprise system integrations, UI/UX design systems, and QA testing.',
    followUpChips: [
      { label: 'Request a Quote', actionKey: 'quote' },
      { label: 'Book Consultation', actionKey: 'book' },
    ],
  },
  contact: {
    actionKey: 'contact',
    response: 'Technook Global HQ is located at Imperial Plaza, Diosdado Macapagal Blvd., Tambo, Parañaque City, Metro Manila. You can reach us at info@technookglobal.com or call +639 56 928 4326.',
    followUpChips: [
      { label: 'Book Consultation', actionKey: 'book' },
      { label: 'Request a Quote', actionKey: 'quote' },
    ],
  },
};
